import { SVGProps, Ref, forwardRef } from 'react';

export const EmptySize48Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <rect x={-1} y={-1} width={50} height={50} stroke="currentColor" strokeWidth={2} />
            </g>
        </g>
    </svg>
));
EmptySize48Glyph.displayName = 'EmptySize48Glyph';
